module.exports = __webpack_public_path__ + "img/Rectangle 18.8f1cc33e.png";